var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from 'axios';
export function getClient(apiConfig) {
    var logger = getLogger(apiConfig);
    var requestID = 0;
    var nextRequestID = function () { return requestID++; };
    function makeRequest(url, payload, config) {
        return new Promise(function (resolve, reject) {
            var id = nextRequestID(), cnf = __assign({ url: url, data: {
                    payload: payload,
                }, method: 'POST' }, config);
            cnf.headers = cnf.headers || {};
            cnf.headers['X-Wa-Wp-Bridge-Request-ID'] = id;
            if (apiConfig.nonce) {
                cnf.headers['X-Wa-Wp-Bridge-Request-Nonce'] = apiConfig.nonce;
            }
            logger.start(id, url, payload);
            axios.request(cnf)
                .then(function (response) {
                if (!response.data || typeof response.data !== 'object') {
                    var data = {
                        error: 'Malformed response',
                        payload: response.data,
                    };
                    logger.reject(id, url, data.error);
                    reject(data);
                }
                else if (response.data.error) {
                    logger.reject(id, url, response.data.error);
                    reject(response.data);
                }
                else {
                    logger.resolve(id, url, response.data);
                    resolve(response.data);
                }
            })
                .catch(function (err) {
                logger.reject(id, url, err);
                reject({
                    error: err && err.toString(),
                    payload: err,
                });
            });
        });
    }
    function makeApiRequest(action, payload, config) {
        return makeRequest("".concat(apiConfig.ajaxurl, "?action=").concat(apiConfig.ajaxAction, "&handler=").concat(action), payload, config);
    }
    return {
        get config() { return apiConfig; },
        request: makeRequest,
        post: makeApiRequest,
        get: function (action, args, config) {
            return makeApiRequest(action, args, __assign({ method: 'GET' }, config));
        },
    };
}
export function getClientEssentials(apiConfig) {
    var config = {
        ajaxurl: (apiConfig && apiConfig.ajaxurl) || '/wp-admin/admin-ajax.php',
        logToConsole: (apiConfig && apiConfig.logToConsole) || true,
        label: (apiConfig.label && apiConfig.label) || 'WP',
        ajaxAction: (apiConfig.ajaxAction && apiConfig.ajaxAction) || null,
    };
    var client = getClient(config);
    return {
        configure: function (c) {
            Object.assign(config, c);
        },
        get: function (action, payload, c) {
            if (c === void 0) { c = {}; }
            return client.request(config.ajaxurl, { action: action, payload: payload }, __assign(__assign({}, c), { method: 'GET' }));
        },
        post: function (action, payload, c) {
            if (c === void 0) { c = {}; }
            return client.request(config.ajaxurl, { action: action, payload: payload }, c);
        },
        request: client.request,
    };
}
function getLogger(config) {
    var label = config.label || 'Server';
    function doLog(method, id, name, color, data) {
        var colors = [
            "color: ".concat(color, "; font-weight: bold"),
            "color: ".concat(color, "; font-size: 1.4em;"),
            'color: #232323; font-weight: bold',
            '', 'color: #4d7ecc; font-weight: bold',
        ];
        var args = ["%c".concat(id, "\t%c\u25D4\t%c").concat(label, "%c:%c").concat(name)].concat(colors).concat(data);
        console[method].apply(null, args);
    }
    return {
        start: function (id, name, params) {
            if (config.logToConsole) {
                doLog('info', id, name, '#757575', params);
            }
        },
        resolve: function (id, name, data) {
            if (config.logToConsole) {
                var display = typeof data === 'string' ? new JustString(data) : data;
                if (config.logToConsole) {
                    doLog('info', id, name, '#659e2c', display);
                }
            }
        },
        reject: function (id, name, error) {
            if (config.logToConsole) {
                doLog('warn', id, name, '#d11723', error);
            }
        },
    };
}
var JustString = /** @class */ (function () {
    function JustString(string) {
        this.string = string;
    }
    return JustString;
}());
